export const NameValidation = [
  { required: true, message: "Field is required" },
];

export const NoteValidation = [
  { max: 10000, message: "Note must have maximum of 10000 charcteres" },
];

export const OfferedAtValidation = [
  { required: true, message: "Field is required" },
];
